<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      {{ t('menu_language') }} <i class="icon-flag"></i>
    </template>
    <template slot="dropdown">
      <b-dropdown-item @click="selectLanguage('en_EN')">English</b-dropdown-item>
      <b-dropdown-item @click="selectLanguage('pl_PL')">Polski</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  methods: {
    selectLanguage (code) {
      this.$translate.setLang(code)
    }
  }
}
</script>
